import { render, staticRenderFns } from "./SelectAddressChip.vue?vue&type=template&id=3eb91c7e"
import script from "./SelectAddressChip.vue?vue&type=script&lang=js"
export * from "./SelectAddressChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports